export const initialData = [
  {
    name: "СВ Грекова Наталья",
    comment: "",
    schedule: [
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "10-18", people: "10", hours: "8" },
      { shift: "9-21", people: "15", hours: "12" },
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "8-20", people: "9", hours: "10" },
      { shift: "9-21", people: "14", hours: "11" },
      { shift: "9-21", people: "13", hours: "13" },
    ],
  },
  {
    name: "Іванов Іван",
    comment: "Потрібно уточнити графік",
    schedule: [
      { shift: "8-16", people: "8", hours: "7.5" },
      { shift: "8-16", people: "8", hours: "7.5" },
      { shift: "9-17", people: "10", hours: "8" },
      { shift: "9-17", people: "10", hours: "8" },
      { shift: "10-18", people: "12", hours: "8" },
      { shift: "8-16", people: "8", hours: "7.5" },
      { shift: "8-16", people: "8", hours: "7.5" },
    ],
  },
  {
    name: "Петренко Марія",
    comment: "",
    schedule: [
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
      { shift: "7-15", people: "9", hours: "8" },
    ],
  },
  {
    name: "Коваленко Сергій",
    comment: "Відпустка з 3 по 7 липня",
    schedule: [
      { shift: "-", people: "0", hours: "0" },
      { shift: "-", people: "0", hours: "0" },
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "9-21", people: "12", hours: "13.5" },
      { shift: "9-21", people: "12", hours: "13.5" },
    ],
  },
  {
    name: "Мельник Олена",
    comment: "",
    schedule: [
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
      { shift: "10-18", people: "11", hours: "8" },
    ],
  },
];

export const days = [
  "Пн, 01.07",
  "Вт, 02.07",
  "Ср, 03.07",
  "Чт, 04.07",
  "Пт, 05.07",
  "Сб, 06.07",
  "Нд, 07.07",
];
